<template>
  <div class="prod_content">
    <div class="prod_head fdc">
      <h3>{{prodSideObj.prodTitle}}</h3>
      <span @click="randomData">{{prodSideObj.prodText}}</span>
    </div>
    <div>
      <div class="prod_middle" @click="toDetail(item)" v-for="(item, index) in prodSideObj.prodData" :key="index">
        <div class="prod_mater">
           <img :src="item.cover" alt="" />
           <img class="model" src="@/assets/images/play.png">
        </div>  
        <div class="prod_info">
          <p class="prod_title">{{item.title}}</p>
          <div v-if="prodSideObj.isShow == true">
              <p class="prod_text" v-if="item.fistprofessorname">
              <span>主讲人 :</span>
              <span>{{item.fistprofessorname}}</span>
          </p>
          <div class="prod_list fdc">
               <p v-if="item.viewerscount">
                 <span>观看人数 :</span>
                 <span>{{item.viewerscount}}</span>
               </p>
               <p v-if="item.price == 0" class="free">免费</p>
               <p class="free" v-else>￥{{item.price}}</p>
          </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { routerGoNewpage } from "../utils/index";
export default {
  props:['prodSideObj'],
  methods:{
    randomData(){
        this.$emit("randomData")
    },
    toDetail(item){
      routerGoNewpage("/environmental_college_detail",{id:item.id});
    }
  },
};
</script>

<style scoped lang="less">
.prod_content {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  padding-bottom: 20px;
}
.prod_head{
    margin-top: 15px;
}
.prod_head h3{
    margin-left: 15px;
}
.prod_head span{
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9a9a9a;
    margin-right: 20px;
}
.prod_head span::before{
    display: inline-block;
    content: "";
    width: 17px;
    height: 17px;
    background: url("../assets/images/break.png") no-repeat center/100%;
    vertical-align: top;
    margin-right: 3px;
}
.prod_middle {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    cursor: pointer;
}
.prod_mater{
   position: relative;
}
.prod_mater img{
   box-sizing: border-box;
   padding: 15px 15px;
   width: 100%;
   height: 192px;
}
.prod_mater img.model{
  position: absolute;
  width: 75px;
  height: 75px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.prod_info{
    padding: 0px 15px;
}
.prod_title{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.prod_text{
    margin-top: 10px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.prod_list{
    margin-top: 5px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    position: relative;
    height: 30px;
}
.free{
  position: absolute;
  color: #FF3000;
  right: 0px;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/common/prodSide.vue